<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/task-notice/table">任务提示列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <layout-panel>
      <span slot="header">表单</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="medium">
            <el-form-item label="上架APP"
                          prop="app_type">
              <el-radio-group v-model="form.app_type">
                <el-radio v-for="item in appTypeOptions"
                          :key="item.value"
                          :label="item.value">{{item.label}}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="提示名称"
                          prop="title">
              <el-input v-model="form.title" />
            </el-form-item>
            <el-form-item label="项目名称"
                          prop="projectid">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                label-key="name"
                value-key="id"
                placeholder="请输入项目名称"
                v-model="form.projectid"
                :query-request="getProjectTable"
                :find-request="getProjectDetail">
              </remote-select>
            </el-form-item>
            <el-form-item label="分步模板"
                          prop="templateid">
              <remote-select
                ref="templateSelect"
                class="width-max"
                clearable
                multiple
                id-key="id"
                label-key="title"
                value-key="id"
                placeholder="请输入模板名称/ID 关键字搜索"
                v-model="form.templateid"
                :query-request="getStepTemplateTable"
                :find-request="getStepTemplateDetail">
              </remote-select>
            </el-form-item>
            <el-form-item label="提示类型"
                          prop="notice_type">
              <el-select v-model="form.notice_type"
                         placeholder="请选择提示类型"
                         class="width-max">
                <el-option
                  v-for="item in [{label: '文字', value: 1}, {label: '图片', value: 2}, {label: '图文', value: 3}]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="提示文案"
                          v-if="[1,3].includes(form.notice_type)"
                          prop="content">
              <el-input type="textarea"
                        placeholder="请输入内容"
                        :rows="5"
                        v-model="form.content" />
            </el-form-item>
            <el-form-item label="上传图片"
                          v-if="[2,3].includes(form.notice_type)"
                          prop="images">
              <avatar-uploader v-model="form.images[0]"
                               accept=".png,.jpeg,.jpg"
                               :max-size="1"
                               :request="uploadTaskNoticeFile"/>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button type="primary"
                     native-type="submit">提交表单
          </el-button>
          <el-button @click="onReload">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
  </div>
</template>

<script>
import { formRules } from '../task-notice.rules.js'
import AvatarUploader from '../components/AvatarUploader'
import { APP_TYPE_ALG, appTypeOptions } from '@utils/appType'

export default {
  components: {
    AvatarUploader
  },
  data () {
    return {
      id: 0,
      formRules,
      appTypeOptions,
      imageUrl: '',
      form: {
        app_type: APP_TYPE_ALG,
        title: '',
        images: [
          ''
        ],
        notice_type: 1,
        content: '',
        projectid: null,
        templateid: [],
      },
    }
  },
  computed: {},
  watch: {},
  beforeRouteEnter (to, from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (to, from, next) {
    this.onReload()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map([
      'getProjectTable',
      'getProjectDetail',
      'getStepTemplateTable',
      'getStepTemplateDetail',
      'uploadTaskNoticeFile',
    ]),
    onLoad () {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id)
      }
    },
    onReload () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.onLoad()
    },
    setForm (id) {
      request.page('getTaskNoticeDetail', {id}).then(({data}) => {
        // 兼容处理：支持数组和单个值
        let templateIds = []
        if (Array.isArray(data.templateid)) {
          templateIds = data.templateid.map(id => String(id))
        } else if (data.templateid) {
          templateIds = [String(data.templateid)]
        }
        data.projectid += ''
        filter.setLoop(this.form, data)

        // 在设置 templateid 之前，先预加载所有模板详情到 RemoteSelect 的 items 中
        if (templateIds.length > 0) {
          // 预加载所有模板详情
          const promises = templateIds.map(templateId => {
            return this.getStepTemplateDetail({id: templateId}).then(({data}) => data)
          })
          Promise.all(promises).then((results) => {
            // 所有模板详情加载完成后，手动添加到 RemoteSelect 的 items 中
            this.$nextTick(() => {
              if (this.$refs.templateSelect) {
                results.forEach(data => {
                  const item = this.$refs.templateSelect.findOption({id: data.id})
                  if (!item) {
                    this.$refs.templateSelect.items.push(data)
                  }
                })
              }
              // 然后设置值
              this.$set(this.form, 'templateid', templateIds)
            })
          }).catch(() => {
            // 即使加载失败，也设置值
            this.$set(this.form, 'templateid', templateIds)
          })
        } else {
          this.$set(this.form, 'templateid', templateIds)
        }
      })
    },
    getForm () {
      this.form.images = this.form.images.filter((one) => !!one)
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createTaskNoticeData', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.form.resetFields()
        }, () => {
          this.$router.push({path: '/task-notice/table/'})
        })
      })
    },
    update (id) {
      request.common('updateTaskNoticeData', {id, ...this.getForm()}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/task-notice/table/'})
        })
      })
    }
  }
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/task-notice/pages/TaskNoticeForm.vue